import { render, staticRenderFns } from "./addFixedPurchase.vue?vue&type=template&id=cf974eb4&scoped=true&"
import script from "./addFixedPurchase.vue?vue&type=script&lang=js&"
export * from "./addFixedPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf974eb4",
  null
  
)

export default component.exports